<template>
  <ul class="nav nav-mobile-menu">
    <li class="nav-item">
      <a class="nav-link" role="button" @click="logout">
        <i class="nc-icon nc-button-power"></i>
        <span class="no-icon">Log out</span>
      </a>
    </li>
  </ul>
</template>
<script>
  export default {
    name: 'mobile-menu',
    methods: {
      logout() {
            localStorage.removeItem("token");
            localStorage.removeItem("roles");
            localStorage.removeItem("permissions");
            this.$store.dispatch("user", null);
            // this.$toasted.success("Logged out Successfull");

            /**
             * Clear PWA Cache on logout
             */
            caches.keys().then((cacheNames) => {
                cacheNames.forEach((cacheName) => {
                    caches.delete(cacheName);
                });
            });
            /**
             * Unregistrer ServiceWorker on logout
             */
            if (window.navigator && navigator.serviceWorker) {
                navigator.serviceWorker
                    .getRegistrations()
                    .then(function (registrations) {
                        for (let registration of registrations) {
                            registration.unregister();
                        }
                    });
            }
            this.$router.push("/admin/login");
        },
    }
  }
</script>
<style>
</style>
